import { AxiosInstance, CancelToken } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/asset';

export class AssetService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getComment(
    params: types.GetCommentParameters,
    cancelToken?: CancelToken,
  ): Promise<types.GetCommentResponse> {
    const { data } = await this.axios.get(`/v1/assets/comments/${params.path.commentId}`, {
      params: new URLSearchParams([
        ...(params.query.include ?? []).map((x) => ['include', x]),
        ...(params.query.orderBy ?? []).map((x) => ['orderBy', x]),
      ]),
      cancelToken,
    });

    return data;
  }

  async getAssetGeometryUrl(
    params: types.GetAssetGeometryUrlParameters,
  ): Promise<common.GetUrlResponse> {
    return (
      await this.axios.get(`/v1/assets/${params.path.dynamicAssetId}/geometry/url`, {
        params: params.query,
      })
    ).data;
  }

  async getPrismVolumeUrl(
    params: types.GetPrismVolumeUrlParameters,
  ): Promise<common.GetUrlResponse> {
    return (
      await this.axios.get(
        `/v1/assets/${params.path.dynamicAssetId}/prismvolume/${params.path.prismVolumeId}/url`,
      )
    ).data;
  }

  async deletePrismVolume(params: types.DeletePrismVolumeParameters): Promise<void> {
    await this.axios.delete(
      `/v1/assets/${params.path.dynamicAssetId}/prismvolume/${params.path.prismVolumeId}`,
    );
  }

  async getExport(params: types.GetExportParameters): Promise<common.GetUrlWithUploadIdResponse> {
    return (
      await this.axios.get(`/v1/assets/${params.path.dynamicAssetId}/export`, {
        params: params.query,
      })
    ).data;
  }

  async createExport(params: types.CreateExportParameters): Promise<types.CreateExportResponse> {
    return (await this.axios.post(`/v1/assets/${params.path.dynamicAssetId}/export`, params.body))
      .data;
  }

  async createPoi(params: types.CreatePoiParameters): Promise<types.CreatePoiResponse> {
    const { data } = await this.axios.post(
      `/v1/assets/poi?projectId=${params.query.projectId}`,
      params.body,
    );

    return data;
  }

  async createPdf(params: types.CreatePdfParameters): Promise<types.CreatePdfAssetResponse> {
    const { data } = await this.axios.post(`/v1/assets/pdf`, params.body, {
      headers: {
        ...params.headers,
      },
    });

    return data;
  }

  async duplicateAsset(
    params: types.DuplicateAssetParameters,
  ): Promise<types.DuplicateAssetResponse> {
    const { data } = await this.axios.post(
      `/v1/assets/${params.path.dynamicAssetId}/duplicate`,
      params.body,
    );

    return data;
  }

  async patchComment(params: types.PatchCommentParameters): Promise<types.PatchCommentResponse> {
    const { data } = await this.axios.patch(
      `/v1/assets/comments/${params.path.commentId}`,
      params.body,
    );
    return data;
  }
}
